// Mídia que a API devolve com caminho relativo (`/storage/...`) na origem da
// própria API. Sem isso o navegador resolve o caminho no domínio principal, e
// lá as regras de vídeo do nginx não existem: o vídeo dá 403 (o making-of da
// home, 07/10). Mesmo critério do BE-4 para o teaser da home: o vídeo fica no
// api.; o token é assinado sobre o caminho, então trocar o host não o invalida.
//
// Sem imports: roda no Nuxt e no node:test.

export const ORIGEM_API = "https://api.belladasemana.com.br";

/** `/storage/...` vira `https://api.belladasemana.com.br/storage/...`; o resto volta como veio. */
export function naOrigemDaApi(url: unknown): unknown {
  if (typeof url !== "string" || !url.startsWith("/storage/")) return url;
  return ORIGEM_API + url;
}
